// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"Divider-horizontal-ce9c","vertical":"Divider-vertical-ce9c","secondary":"Divider-secondary-ce9c","tertiary":"Divider-tertiary-ce9c"};